<template>
    <div id="skip-owner-confirmation">
        <div class="flex align-center">
            <vs-switch v-model="key_active" class="my-3" @click="updateActive"/>
            <span class="pl-5">You don't need to confirm your online bookings, which means all online bookings from your customers will be automatically confirmed right after they book.</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'skip-owner-confirmation',
    data() {
        return {
            key_active: false,
            type_err: '',
            loaded_data_num: 0,
            action_type: ''
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 1) {
                    this.closeLoading();
                } else {
                    this.action_type = 'Get data';
                    this.openLoadingInDiv();
                }
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: this.action_type + ' Skip Owner Confirmation Failed',
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.isOpenLoading = false;
            setTimeout(() => {
                this.$vs.loading.close('#app > .con-vs-loading')
            }, 500);
        },
        updateActive() {
            const obj = {
                key: 'module.appointment.skip_owner_confirm',
                value: !this.key_active ? 1 : 0
            }
            this.action_type = 'Update';
            this.openLoadingInDiv();
            this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                title:'Notification',
                text:'Update Skip Owner Confirmation Success',
                color:'success',
                position:'top-right'})
            }).catch(() => {
                this.$vs.notify({
                title:'Notification',
                text:'Update Skip Owner Confirmation Failed',
                color:'danger',
                position:'top-right'})
            })
        }
    },
    created(){
        const obj = {
            key: 'module.appointment.skip_owner_confirm'
        }

        this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
            this.loaded_data_num++;
            //   this.$emit('LoadDataComplete');
            let appointment = {};
            appointment = this.$store.getters["appSetting/keyStorage"];
            this.key_active = appointment.value == 1 ? true : false
        }).catch(() => {
            const obj = {
                key: 'module.appointment.skip_owner_confirm',
                value: 0
            }
            this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
                this.loaded_data_num++;
            })
        })
    }
}
</script>